export const hasInjectionValue = (value) =>
  Array.isArray(value)
    ? value.length > 0
    : value !== null && value !== undefined && value !== "";

export const isInjectionSectionVisible = (employee, section) =>
  employee?.visibleSections?.personalInfo?.includes(section) ||
  employee?.visibleSections?.jobSalaryHolidays?.includes(section);

// Each descriptor supplies the same value conversion and target as its table cell.
export const applyBulkInjection = ({ employees, fields, values, setValue }) => {
  employees.forEach((employee, employeeIndex) => {
    if (!employee?.selected) return;
    fields.forEach((field) => {
      const value = values[field.id];
      if (
        field.disabled ||
        !hasInjectionValue(value) ||
        !isInjectionSectionVisible(employee, field.section) ||
        (field.canApply && !field.canApply(employee))
      )
        return;
      const write = (path, nextValue) =>
        setValue(`employees.${employeeIndex}.${path}`, nextValue, {
          shouldDirty: true
        });
      if (field.apply) field.apply(employee, value, write);
      else write(field.path, field.toValue ? field.toValue(value) : value);
    });
  });
};
